import { inject, Injectable, signal } from '@angular/core';

import { TellentNavigationGroup } from '@core/tellent-types';

import { TellentNavigationDataFacade } from '../tellent-navigation-data.facade';
import { TellentNavigationRoutingService } from './navigation-routing.service';
import { TellentNavigationViewModelBuilder } from './navigation-view-model.builder';
import { TellentNavigationController } from './navigation.controller';

@Injectable({
  providedIn: 'root',
})
export class TellentSettingsNavigationController extends TellentNavigationController {
  #navRoutingSvc = inject(TellentNavigationRoutingService);
  #navDataSvc = inject(TellentNavigationDataFacade);
  #viewModelBuilder = inject(TellentNavigationViewModelBuilder);

  public minimized = signal(false).asReadonly();
  public viewModel = this.#viewModelBuilder.viewModel;

  public setUserSelectedGroup(group: TellentNavigationGroup) {
    this.#viewModelBuilder.userSelectedGroup.set(group.isExpanded ? null : group);
  }

  public clearUserSelectedGroup() {
    this.#viewModelBuilder.userSelectedGroup.set(null);
  }

  public handleNavigationLinkClick(url: string) {
    this.#navRoutingSvc.navigate(url);
  }

  public refresh() {
    this.#navDataSvc.refreshMainNav();
  }
}
